import availableLoginsQuery from '../../api-v2/queries/available-login-query';

function getErrorDetails(error) {
  if (!error) {
    return null;
  }

  if (error === 'access_denied') {
    return 'Could not validate your credentials. Please try again.';
  }
}

export default function loginPageLoader(queryClient) {
  return async () => {
    const searchParams = new URLSearchParams(window.location.search);
    queryClient.ensureQueryData(availableLoginsQuery());

    return { error: getErrorDetails(searchParams.get('error')) };
  };
}
